import { render } from "./Kegiatancsrisi.vue?vue&type=template&id=57d8fbf4"
import script from "./Kegiatancsrisi.vue?vue&type=script&lang=js"
export * from "./Kegiatancsrisi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__